import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { RootURLS } from "constants/in-app-urls";
import Cookies from "js-cookie";

const RestrictRoute = () => {
    const systemTokenForAuth = Cookies.get("system_token");

    if (systemTokenForAuth) {
        return <Navigate to={`${RootURLS.HOME_URL}`} />;
    }

    const auth = { token: localStorage.getItem("id") };
    return auth.token ? <Navigate to="/on-boarding" /> : <Outlet />;
};

export default RestrictRoute;
